"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const svg_1 = require("../../../svg");
exports.WorkflowDynamicLogo = (_a) => {
    var { status } = _a, props = tslib_1.__rest(_a, ["status"]);
    let Comp;
    if (status === 'succeeded') {
        Comp = svg_1.WorkflowsSuccess;
    }
    else if (status === 'failed') {
        Comp = svg_1.WorkflowsFailure;
    }
    else if (status === 'scheduled') {
        Comp = svg_1.WorkflowsScheduled;
    }
    else if (status === 'cancelled') {
        Comp = svg_1.WorkflowsCancelled;
    }
    else if (status === 'paused') {
        Comp = svg_1.WorkflowsPaused;
    }
    else {
        Comp = svg_1.WorkflowsLogo;
    }
    return react_1.default.createElement(Comp, Object.assign({}, props));
};
// export const DynamicWorkflowRunStatusLogo: FC<IProps> = props => {
//   const { status, width, height } = props;
//   const logoProps = {
//     height,
//     width,
//   };
//   let logo = <WorkflowsLogo {...logoProps} />;
//   if (status === 'cancelled') {
//     logo = <WorkflowsCancelled {...logoProps} />;
//   } else if (status === 'failed') {
//     logo = <WorkflowsCancelled {...logoProps} />;
//   } else if (status === 'paused') {
//     logo = <WorkflowsPaused {...logoProps} />;
//   } else if (
//     status === 'pendingApproval' ||
//     status === 'running' ||
//     status === 'proofSentNoApprovalNeeded' ||
//     status === 'scheduled'
//   ) {
//     logo = <WorkflowsScheduled {...logoProps} />;
//   } else if (status === 'succeeded') {
//     logo = <WorkflowsSuccess {...logoProps} />;
//   }
//   return <>{logo}</>;
// };
//# sourceMappingURL=WorkflowDynamicLogo.js.map